import { render } from "./Quiz.vue?vue&type=template&id=313b701a&scoped=true"
import script from "./Quiz.vue?vue&type=script&lang=js"
export * from "./Quiz.vue?vue&type=script&lang=js"

import "./Quiz.vue?vue&type=style&index=0&id=313b701a&scoped=true&lang=css"

import exportComponent from "/Users/am/Projects/jeet_edit/quiztest_edit/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-313b701a"]])

export default __exports__